__turbopack_context__.v({
  "buttonSection": "gshG3a_buttonSection",
  "buttonWrapper": "gshG3a_buttonWrapper",
  "dropdownMenu": "gshG3a_dropdownMenu",
  "dropdownWrapper": "gshG3a_dropdownWrapper",
  "flexColumn": "gshG3a_flexColumn",
  "mainBox": "gshG3a_mainBox",
  "navItem": "gshG3a_navItem",
  "navItemContainer": "gshG3a_navItemContainer",
  "shopItems": "gshG3a_shopItems",
  "shopItemsList": "gshG3a_shopItemsList",
  "shopItemsTitle": "gshG3a_shopItemsTitle",
  "shopSubItemsTitle": "gshG3a_shopSubItemsTitle",
  "subItemContent": "gshG3a_subItemContent",
  "subItemWrapper": "gshG3a_subItemWrapper",
  "subNavItem": "gshG3a_subNavItem",
});
